import { memo } from "react";

import dayjs from "dayjs";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

import { Finding } from "stores/FindingStore";

// -----------------------------------------------------------------------------

const SelectedFindings = memo(function SelectedFindings({
  findings,
}: SelectedFindingsProps): JSX.Element | null {
  if (findings.length < 0) return null;

  return (
    <List
      sx={{
        listStyleType: "disc",
        pl: 3,
        pt: 0,
        pb: 2,
      }}
    >
      {findings.map((finding) => {
        return (
          <ListItem
            sx={{
              display: "list-item",
              pl: 1,
              pr: 0,
              pb: 0,
            }}
            key={finding.uuid}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                {finding.name}
              </Typography>
              <Typography
                variant="body1"
                sx={{ whiteSpace: "nowrap", color: "text.secondary", ml: 1 }}
              >
                {dayjs(finding.create_time).fromNow()}
              </Typography>
            </Box>
          </ListItem>
        );
      })}
    </List>
  );
});

export default SelectedFindings;

// -----------------------------------------------------------------------------

interface SelectedFindingsProps {
  findings: Finding[];
}
